/* eslint-disable @typescript-eslint/no-explicit-any */
import * as jsxRuntime from 'react/jsx-runtime';
const { jsx: baseJsx, jsxs: baseJsxs, Fragment } = jsxRuntime;
/**
 * Creates a custom JSX runtime that injects additional props (like `customIcons`) into all components,
 * excluding React Fragments. Useful for augmenting component behavior globally.
 *
 * @param {{ [iconName: string]: React.FC<any> }} [customIcons] - Optional map of custom icons to inject into components.
 * @returns {{
 *   jsx: (type: ComponentType, props: any, key?: string) => React.ReactElement,
 *   jsxs: (type: ComponentType, props: any, key?: string) => React.ReactElement,
 *   Fragment: typeof React.Fragment
 * }} A custom JSX runtime with prop injection capabilities.
 */
export function createCustomJsxRuntime(customIcons) {
    function injectProps(type, props) {
        if (type === Fragment)
            return props;
        return Object.assign(Object.assign({}, props), { customIcons });
    }
    function jsx(type, props, key) {
        return baseJsx(type, injectProps(type, props), key);
    }
    function jsxs(type, props, key) {
        return baseJsxs(type, injectProps(type, props), key);
    }
    return { jsx, jsxs, Fragment };
}
